import { useCallback } from 'react';
import { IScheduleFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import { ModalSliceType, openModal } from '../../../redux/slices/modal';

export default () => {
  const dispatch = useAppDispatch();

  const isExecuteScheduleModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.ExecuteSchedule, ''),
  );

  const handleOpenExecuteScheduleModal = useCallback(
    (schedule: IScheduleFieldsFragment) => {
      dispatch(
        openModal({ type: ModalSliceType.ExecuteSchedule, data: schedule }),
      );
    },
    [dispatch],
  );

  const isDeleteScheduleModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DeleteSchedule, ''),
  );

  const handleOpenDeleteScheduleModal = useCallback(
    (schedule: IScheduleFieldsFragment) => {
      dispatch(
        openModal({ type: ModalSliceType.DeleteSchedule, data: schedule }),
      );
    },
    [dispatch],
  );

  const isEditScheduleModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.EditSchedule, ''),
  );

  const handleOpenEditScheduleModal = useCallback(
    (schedule: IScheduleFieldsFragment) => {
      dispatch(
        openModal({ type: ModalSliceType.EditSchedule, data: schedule }),
      );
    },
    [dispatch],
  );

  return {
    isExecuteScheduleModalOpen,
    handleOpenExecuteScheduleModal,
    isDeleteScheduleModalOpen,
    handleOpenDeleteScheduleModal,
    isEditScheduleModalOpen,
    handleOpenEditScheduleModal,
  };
};
